import * as React from 'react';
import { Trans } from '@lingui/macro';
import { TAddType, UncastedOnboarding, UncastedPhysicalTAdd } from '@goldwasserexchange/oblis-frontend-utils';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { UserSelect } from '../../../../../../../../../../tAdd';
import { isTAddDisabledTitular, tAddTitularsNeedRepresentative, isTAddMinor } from '../../../../../../../../../../tAdd/utils';
import {
  makeRequired, nilValidator, numberValidator,
} from '../../../../../../../../../../../OUI/Inputs';
import { makeWhenAlwaysCast } from '../../../../../../../../../../Form/validations/whenAlwaysCast';

const representativeSelectInputValidatorDependencyPaths: (keyof UncastedOnboarding)[] = [
  'users',
];

export const representativeSelectInputValidator = makeWhenAlwaysCast(representativeSelectInputValidatorDependencyPaths, (users) => {
  const needRepresentative = tAddTitularsNeedRepresentative(users);
  if (needRepresentative) {
    return makeRequired(numberValidator);
  }
  return nilValidator;
});

const representativeSelectLabel = <Trans>Sélectionnez un représentant légal</Trans>;

const label = (
  <TopModel name="SelectInputLabelContent">
    {representativeSelectLabel}
  </TopModel>
);
export const isNotMinorOrDisabledTitular = (tAdd: UncastedPhysicalTAdd): boolean => {
  if (tAdd.T_ADD_type === TAddType.ONLY_REPRESENTATIVE) {
    return true;
  }
  if (isTAddMinor(tAdd)) {
    return false;
  }
  if (isTAddDisabledTitular(tAdd)) {
    return false;
  }
  return true;
};

export const RepresentativeSelectInput = (props: {
  children?: React.ReactNode,
}) => {
  const {
    children,
  } = props;
  return (
    <UserSelect
      filterFn={isNotMinorOrDisabledTitular}
    >
      {label}
      {children}
    </UserSelect>
  );
};
